require('/opt/odin/app/frontend/pages/question/components/search/index.module.scss');module.exports = "../../app/cells/pages/question/search/show.erb";